export default "assets/images/stries-59701a99.svg";